import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Box, Grid, Autocomplete, TextField } from '@mui/material';
import './index.css';
import _ from 'lodash';
import DateFilter from '../ScheduledReport/DateFilter';

export type FilterType = 'autocomplete' | 'date';

export interface FilterOption {
  label: string;
  name: string;
}

export interface FilterConfig {
  key: string;
  label: string;
  type: FilterType;
  _options?: FilterOption[]; // only for autocomplete;
  placeholder?: string; // only for autocomplete
}

export type FilterValue = string[] | Date | null;

export type FilterValues = Record<string, FilterValue>;
interface FiltersProps {
  config: FilterConfig[];
  values: FilterValues;
  onChange: (key: string, value: FilterValue) => void;
}

const TableFilters: React.FC<FiltersProps> = ({ config, values, onChange }) => {
  const renderField = (filter: FilterConfig) => {
    const _value: any = values[filter.key];

    const getOptionDisabled = (option: any) => {
      let render_option = 'All';
      if (_value?.findIndex((item) => item?.name === render_option) !== -1)
        return true;
      if (
        option.name === render_option &&
        _value[0]?.name &&
        _value[0]?.name !== render_option
      )
        return true;
      if (_value.find((ele) => ele.name == option.name)) return true;
      return false;
    };

    switch (filter.type) {
      case 'autocomplete':
        return (
          <Autocomplete
            className='select-site-input'
            fullWidth
            size='small'
            multiple
            limitTags={1}
            options={filter._options || []}
            value={[...(_value || [])]}
            getOptionLabel={(option: any) => option.name}
            getOptionDisabled={getOptionDisabled}
            ListboxProps={{
              className: 'warehouse-apply-config-props',
            }}
            onChange={(e, newValue) => {
              onChange(filter.key, newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                placeholder={filter.placeholder}
                style={{ fontSize: '11px' }}
              />
            )}
          />
        );

      case 'date':
        return <DateFilter date_value={_value} handleDateChange={onChange} />;

      default:
        return null;
    }
  };

  return (
    <Box className='l-shaped-filters-subscription-report'>
      <div style={{ height: '250px', overflowY: 'scroll' }}>
        {config.map((filter) => {
          return (
            <Grid className='report-filter-grid'>
              <div className='Form'>
                <Grid className='am-table'>
                  <Grid className='dash-filter-pop'>
                    <Grid>
                      <Grid>
                        <Grid className='internetr-status-header-paddingBottom'>
                          <span className='internet-status-header'>
                            {filter.label}
                          </span>
                        </Grid>
                        <Grid className='internetr-status-header-paddingBottom'>
                          {renderField(filter)}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          );
        })}
      </div>
    </Box>
  );
};

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps, {})(TableFilters));
